
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#e6e6e6"}}),_c('path',{attrs:{"d":"M115.33,89.77,88.05,55.34l-29-3.24L55.71,82.32l31.09,40a3.15,3.15,0,0,0,4.44.5l23.9-19.1M69.59,70.91a5,5,0,1,1,5.53-4.42,5,5,0,0,1-5.53,4.42Zm0,0","transform":"translate(-.67 -.67)","fill":"#e6e6e6","stroke":"#3b7cf7","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M68.91,61.09A2.63,2.63,0,0,1,70.24,65c-1.45,2.09-3.79.17-4.42-.76-2.11-3.16-5.29-36-29.55-29.42","transform":"translate(-.67 -.67)","fill":"none","stroke":"#3b7cf7","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    